export default __webpack_public_path__ + "static/media/SearchJournal_Dark2.961ee074.svg";